(function (t) {
// uk
t.add("label_previous", "\u041d\u0430\u0437\u0430\u0434", "KnpPaginatorBundle", "uk");
t.add("label_next", "\u0414\u0430\u043b\u0456", "KnpPaginatorBundle", "uk");
})(Translator);
